import { TSponsor } from "Types/Models"

export const CoursePartners = ({
   data,
   sponsor_text,
   show = true,
}: {
   data: TSponsor[]
   sponsor_text: string
   show: boolean
}) => {
   return (
      <div
         className={`border-t container mx-auto mt-5 flex-col justify-center items-center pt-6 border-gray/20 ${
            show ? "hidden md:flex" : "flex! md:hidden!"
         }`}>
         <p className={`text-black/70 my-16 ${!show && "text-center"}`}>{sponsor_text}</p>
         <div className='flex justify-center gap-20 items-center flex-wrap mb-10'>
            {data.map((sponsor) => (
               <a target={"_blank"} key={sponsor.id} href={sponsor.link} rel='noreferrer'>
                  <img
                     className='w-[100px] lg:w-[150px] aspect-square object-contain'
                     src={process.env.REACT_APP_MEDIA_URL + sponsor.logo}
                  />
               </a>
            ))}
         </div>
      </div>
   )
}
